import {System} from "./Models";
import {API_BASE} from "./ApiClient";

import axios, {AxiosResponse} from 'axios';

export default class SystemApi {
  private jwtToken: string|null

  constructor(jwtToken: string|null) {
    this.jwtToken = jwtToken
  }

  systems(): Promise<System[]> {
    return axios.get(API_BASE + '/systems', {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<System[]>) => {
        return response.data;
      })
  }

  addSystem(name: string): Promise<System> {
    return axios.post(API_BASE + '/systems', {
      name
    }, {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<System>) => {
        return response.data;
      })
  }

  updateSystem(id: string, name: string): Promise<System> {
    return axios.put(API_BASE + '/systems/' + id, {
      name
    }, {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<System>) => {
        return response.data;
      })
  }
};